import React from "react";
import Helmet from "react-helmet";
import Analytics from "../utils/analytics";

export default class LoginTermAccept extends React.Component {
    constructor(props) {
        super(props);
        const amz_params = window.location.search;
        this.params = amz_params;
        this.handleAcceptTerms = this.handleAcceptTerms.bind(this);
    }

    componentDidMount() {
        let analytics = new Analytics(
            {
                page_sub_function: "main",
                page_name: "view",
                page_function: "acknowledge",
                device: "mobi",
                country_language: "en"
            },
            this.props.config.analytics
        );

        // Send update on "page load"
        analytics.triggerBootstrap();
    }

    handleAcceptTerms(event) {
        event.preventDefault();
        this.props.onPush();
    }

    render() {
        return (
            <div className="container terms">
                <Helmet>
                    <title>{this.props.config.product}</title>
                </Helmet>
                <h1>
                    Please read and agree to the usage terms and conditions
                    below
                </h1>
                <div className="login-terms">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.props.config.terms
                        }}
                    />
                </div>

                <h4>
                    I acknowledge that by clicking "Accept", I agree to these
                    terms and conditions.{" "}
                </h4>
                <button
                    name="btnLogin"
                    onClick={this.handleAcceptTerms}
                    className="ensightencustomevent" // Analytics Class
                    data-label="accept" // Analytics Label
                >
                    Accept
                </button>
            </div>
        );
    }
}
